angular.module('leanlaw').controller('ClientMatterBillablesCtrl3', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', 'alerts', 'userService', 'reportsService', 'commonFilterService', 'exportJson', 'singleRequest', 'objectNumberManipulator', 'messageBus', 'clientManager', function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, objectNumberManipulator, messageBus, clientManager) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = '';
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          let exportMatter = {
            'ID': c.client.reference || '',
            'Client': c.client.name,
            [matter]: '',
            'Non-billable Hours': $filter('hoursDecimal')(c.data.hours.nonBillable),
            'Billable Hours': $filter('hoursDecimal')(c.data.hours.billable),
            'Hours Amount': $filter('amount')(c.data.amounts.hours)
          };

          // Conditionally add "Fixed Fee Hours" if the feature is enabled
          exportMatter['Fixed Fee Hours'] = $filter('hoursDecimal')(c.data.hours.charges);
          exportMatter = {
            ...exportMatter,
            'Fixed Fees': $filter('amount')(c.data.amounts.charges),
            'Expenses': $filter('amount')(c.data.amounts.expenses),
            'Total Amount': $filter('amount')(c.data.amounts.total)
          };
          accum.push(exportMatter);
        } else {
          let exportClient = {
            'ID': c.client.reference || '',
            'Client': c.client.name,
            'Non-billable Hours': $filter('hoursDecimal')(c.data.hours.nonBillable),
            'Billable Hours': $filter('hoursDecimal')(c.data.hours.billable),
            'Hours Amount': $filter('amount')(c.data.amounts.hours)
          };
          exportClient['Fixed Fee Hours'] = $filter('hoursDecimal')(c.data.hours.charges);
          exportClient = {
            ...exportClient,
            'Fixed Fees': $filter('amount')(c.data.amounts.charges),
            'Expenses': $filter('amount')(c.data.amounts.expenses),
            'Total Amount': $filter('amount')(c.data.amounts.total)
          };
          accum.push(exportClient);
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        let exportMatterWithoutReference = {
          ID: c.client.reference || '',
          Client: c.client.name,
          [matter]: '',
          'Non-billable Hours': $filter('hoursDecimal')(c.data.hours.nonBillable),
          'Billable Hours': $filter('hoursDecimal')(c.data.hours.billable),
          'Hours Amount': $filter('amount')(c.data.amounts.hours)
        };
        exportMatterWithoutReference['Fixed Fee Hours'] = $filter('hoursDecimal')(c.data.hours.charges);
        exportMatterWithoutReference = {
          ...exportMatterWithoutReference,
          'Fixed Fees': $filter('amount')(c.data.amounts.charges),
          'Expenses': $filter('amount')(c.data.amounts.expenses),
          'Total Amount': $filter('amount')(c.data.amounts.total)
        };
        accum.push(exportMatterWithoutReference);
      } else {
        let exportClientWithoutReference = {
          'Client': c.client.name,
          'Non-billable Hours': $filter('hoursDecimal')(c.data.hours.nonBillable),
          'Billable Hours': $filter('hoursDecimal')(c.data.hours.billable),
          'Hours Amount': $filter('amount')(c.data.amounts.hours)
        };
        exportClientWithoutReference['Fixed Fee Hours'] = $filter('hoursDecimal')(c.data.hours.charges);
        exportClientWithoutReference = {
          ...exportClientWithoutReference,
          'Fixed Fees': $filter('amount')(c.data.amounts.charges),
          'Expenses': $filter('amount')(c.data.amounts.expenses),
          'Total Amount': $filter('amount')(c.data.amounts.total)
        };
        accum.push(exportClientWithoutReference);
      }
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          let exportIncludesMatter = {
            'ID': m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            'Client': '',
            [matter]: m.matter.name,
            'Non-billable Hours': $filter('hoursDecimal')(m.data.hours.nonBillable),
            'Billable Hours': $filter('hoursDecimal')(m.data.hours.billable),
            'Hours Amount': $filter('amount')(m.data.amounts.hours)
          };
          exportIncludesMatter['Fixed Fee Hours'] = $filter('hoursDecimal')(m.data.hours.charges);
          exportIncludesMatter = {
            ...exportIncludesMatter,
            'Fixed Fees': $filter('amount')(m.data.amounts.charges),
            'Expenses': $filter('amount')(m.data.amounts.expenses),
            'Total Amount': $filter('amount')(m.data.amounts.total)
          };
          accum.push(exportIncludesMatter);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.distributionId = undefined;
      $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
      // if (payload.filter.range) filterClientEntries();

      filterClientEntries();
    });
    $scope.$on('report-sidebar-filterchange', (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
    $scope.$on('report-clientmatter-change', (event, cm) => {
      singleRequest.cancel('clientEntries');
      $scope.goToSummary(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage('filterDependency-ready', true);
    messageBus.addMessage('clientmatter-set', true, {});
  });
  function filterClientEntries() {
    $scope.loading = true;
    $scope.data = null;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.data = 'services,expenses,charges,hours';
    query.reportType = 'billable';
    singleRequest.apiCall('client-matter-billables', true).getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel('client-matter-billables');
    deactivate();
  });

  // MatterId may be optional
  $scope.goToSummary = function (clientId, matterId) {
    $state.go('reports.client-summary', {
      clientId,
      matterId,
      return: 'reports.client-matter-billables',
      report: `Client and ${$scope.me.terms.Matter} Billables`
    });
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);